/* Copyright (C) 2021 ev-i Informationstechnologie GmbH */

export enum TaskSearchMode {
    OWN = "OWN",
    OPEN = "OPEN",
    DONE = "DONE",
    LATE = "LATE",
    BATCH = "BATCH"            
}
